import React from 'react';
import styles from './TablaPartidosBase.module.css';

/**
 * Componente base para estructura de tabla de partidos
 * Define colgroup + thead, recibe tbody como children
 * NO incluye columna Zona (los partidos se muestran agrupados por zona)
 */
const TablaPartidosBase = (props) => {
  const {
    mostrarOrdenPartido = false,
    mostrarBotonesEdicion = false,
    tituloGrupo = null,
    children, // tbody content
  } = props;

  return (
    <React.Fragment>
      {tituloGrupo && <div className={styles.tituloGrupo}>{tituloGrupo}</div>}
      <table className={styles.tabla}>
        <colgroup>
          {mostrarOrdenPartido && <col className={styles.ordenPartido} />}
          <col className={styles.fecha} />
          <col className={styles.equipoLocal} />
          <col className={styles.resultado} />
          <col className={styles.equipoVisitante} />
          {mostrarBotonesEdicion && <col className={styles.botones} />}
        </colgroup>
        <thead>
          <tr>
            {mostrarOrdenPartido && <th className={styles.ordenPartido}>#</th>}
            <th className={styles.fecha}>Día</th>
            <th className={styles.equipoLocal}>Local</th>
            <th className={styles.resultado}>Res</th>
            <th className={styles.equipoVisitante}>Visitante</th>
            {mostrarBotonesEdicion && <th className={styles.botones}></th>}
          </tr>
        </thead>
        {children}
      </table>
    </React.Fragment>
  );
};

export default TablaPartidosBase;
